// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"202ab0db","591":"e7e8ed35","680":"425eb808"}[chunkId] + ".chunk.js";
};